import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GiftCardDto } from "src/app/shared/models/DTO/gift-card.dto";
import { GiftProcessors } from "src/app/shared/models/enums/gift-processors.enum";
import { EGiftTransactionsComponent } from "../../../reports/e-gift-transactions/e-gift-transactions.component";

@Component({
	selector: "app-gift-card-view",
	templateUrl: "./gift-card-view.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class GiftCardViewComponent implements OnInit {
	@ViewChild("eGiftTransactionsComponent") eGiftTransactionsComponent: EGiftTransactionsComponent;

	tabView: number = 0;
	cards: GiftCardDto[];
	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		if (this.venueService.subscriptionOOvenue.value?.giftProcessor === GiftProcessors.FOCUSCA) {
			this.getGiftcards(this.venueService.subscriptionVenue.value.key);
		}
	}

	async getGiftcards(venueKey: number) {
		const resp = await this.focuslink.giftCardGetAll(venueKey);
		this.cards = resp.map((i) => {
			return new GiftCardDto(i);
		});
	}

	addTransaction() {
		this.eGiftTransactionsComponent.adhocTransaction();
	}

	changeTab(event) {
		this.tabView = event.index;
	}
}
